import { Col, Container, Row } from 'styled-bootstrap-grid';
import { Helmet } from 'react-helmet';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import PageTitle from "../../PageTitle/components/PageTitle";
import PageNavigation from '../../PageNavigation/components/PageNavigation';

const Content = styled.div`
  h1 {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
  }
  h2 {
    color: #76797E;
    font-size: 3rem;
    font-weight: 400;
    margin: 1rem 0 8rem;
    padding: 0;
    line-height: 4rem;
  }
  h3 {
    color: #212529;
    font-size: 1.5rem;
    font-weight: 400;
    margin-top: 2rem;
    line-height: 3rem;
    text-transform: capitalize;
  }
  h4 {
    font-size: 1.1rem;
    font-weight: 700;
    margin: 1.5rem 0 .5rem;
  }
  p {
    color: #717476;
    font-size: 1.25rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
    font-weight: 400;
  }
`;

const Press = () => {
  // https://app.crayon.co/inspire/page/12227 (canary example)
  return <Fragment>
    <Helmet>
      <meta name="description" content="We create brand experiences. Through strong creative, development, devops, digital marketing, quality assurance, and strategy, we help companies build modern digital experiences for their customers." />
      <title>Share Our Story | RMG</title>
      <link rel="canonical" href="https://www.rmgmedia.com/press/" />
    </Helmet>
    <PageTitle  heading="Press"
                subHeading="Share our story."
    />
    <Content>
      <Container>
        <Row>
          <Col col={12}>
            <p>We create brand experiences. In 2013, RMG Media, LLC was founded to help businesses solve real-world problems using leading-edge digital technology and marketing strategies. Through strong creative, development, devops, digital marketing, quality assurance, and strategy, we help companies fill gaps with internal staffing to build modern experiences for their customers online.</p>

            {/* <h2>LOGOS</h2>
            <p>Download logos here: [link]</p>

            <h2>PHOTOGRAPHY</h2>
            <p>Download photos here: [link]</p>

            <h2>VIDEO</h2>
            <p>Download video here: [link]</p> */}

            <h3>leadership</h3>
            <h4>Ryan Gellis</h4>
            <p><span style={{fontStyle: "italic"}}>Managing Partner</span><br />Leads growth, strategy and vision; previously ran R&D and Interactive departments for full-service digital agencies; former strategist and enterprise commerce architect.<br /><a href="https://www.linkedin.com/in/ryan-gellis-3223623b/" target="_blank" rel="noreferrer noopener">LinkedIn</a></p>
            <h4>Michael Caruso</h4>
            <p><span style={{fontStyle: "italic"}}>Managing Partner</span><br />Manages operations and finance; previously ran global financial projections for Fortune 100 enterprises; former technologist and enterprise systems architect.<br /><a href="https://www.linkedin.com/in/mike-caruso-1baa323b/" target="_blank" rel="noreferrer noopener">LinkedIn</a></p>
        
            <h3>contact</h3>
            <p>If you would like to contact us about a story, speaking engagement, or for more information, please email:<br /><a href="mailto:press@rmgmedia.com">press@rmgmedia.com</a></p>
          </Col>
        </Row>
      </Container>
    </Content>
    <PageNavigation prev="platforms" next="openSource" />
  </Fragment>
};

export default Press;
